import { useEffect, useMemo, useState } from 'react'
import { VisibilityState } from '@tanstack/react-table'

import { useAuthStore } from '@/store/auth-store'
import { Role } from '@/types/auth'
import { DISRUPTIONS_COLUMNS } from '../constant'

export const useManageDisruptionsColumns = () => {
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({})
    const { role } = useAuthStore()

    const columnsVisibilityByRole = useMemo<VisibilityState>(() => {
        const state: VisibilityState = {}

        if (role === Role.Controller) {
            state[DISRUPTIONS_COLUMNS.NmccInformed] = false
        }

        if (role === Role.MileageClerk) {
            state[DISRUPTIONS_COLUMNS.Status] = false
            state[DISRUPTIONS_COLUMNS.NmccInformed] = false
        }

        if (role === Role.Reader) {
            state[DISRUPTIONS_COLUMNS.NmccInformed] = false
        }

        return state
    }, [role])

    useEffect(() => {
        setColumnVisibility(columnsVisibilityByRole)
    }, [columnsVisibilityByRole])

    return columnVisibility
}
